import type { GetServerSidePropsContext } from "next/types";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import ToolPageLayout from "components/ToolPageLayout";
import ToolSmartScoreScreener from "components/ToolSmartScoreScreener";
import type { NextPageWithLayout } from "pages/_app";
import Error from "pages/_error";
import {
  authenticatedAccountUrl,
  sessionFromContextCookie,
} from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";

const ToolSmartscoreScreenerPage: NextPageWithLayout = ({}: any) => {
  return <ToolSmartScoreScreener />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const session = sessionFromContextCookie(context);
    const accountId = session?.authenticated?.account_id;
    const accountUrl = authenticatedAccountUrl(accountId);
    const account = await baseFetcher(accountUrl, context);

    const res = await fetch(
      "https://api.quiddityresearch.co/hkg-nb-monitor/latest"
    );
    const content = await res.text();

    try {
      await baseFetcher(
        `/api/v2/tools/smartkarma-smartscore-screener?public_allowed=true`,
        context
      );
    } catch {}

    return {
      props: {
        fallback: {
          [accountUrl]: account,
        },
        iframes: content.split("\n").map((iframe) => iframe),
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps SmartScore Screener Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return {
      props: {
        fallback: {},
      },
    };
  }
}

ToolSmartscoreScreenerPage.getLayout = (page, { pageProps }) => {
  const { fallback, errorCode } = pageProps;

  if (errorCode) return <Error statusCode={errorCode} />;

  return (
    <SWRConfig value={{ fallback }}>
      <ToolPageLayout
        breadcrumb={[
          {
            title: "SmartScore Screener",
            href: `/tools/smart-score-screener`,
            icon: (
              // eslint-disable-next-line @next/next/no-img-element
              <img
                src="https://assets.smartkarma.com/tools/filter-black.svg"
                alt="smartscore screener"
                className="w-[18px] h-[18px]"
                width="auto"
                height="auto"
              />
            ),
          },
        ]}
        title="SmartScore Screener"
        description="Screen for companies using their SmartScore, a compound score for a company indicating its overall outlook based on key factors."
      >
        {page}
      </ToolPageLayout>
    </SWRConfig>
  );
};

export default ToolSmartscoreScreenerPage;
